var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    staticClass: "auth-callback-content",
    attrs: {
      "aria-live": "polite",
      "aria-atomic": "true"
    }
  }, [_c('div', {
    staticClass: "auth-callback-content__status"
  }, [_vm.busy ? _c('Loader') : _vm.failed ? _c('i', {
    staticClass: "mdi mdi-alert-circle-outline text-danger",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()], 1), _c('h1', {
    staticClass: "auth-callback-content__message subtitle-1"
  }, [_vm._v(_vm._s(_vm.message))]), _vm.showSlow && !_vm.failed ? _c('p', {
    staticClass: "auth-callback-content__hint display-2"
  }, [_vm._v(" " + _vm._s(_vm.slowMessage) + " ")]) : _vm._e(), _vm.showActions ? _c('div', {
    staticClass: "auth-callback-content__actions"
  }, [_c('b-button', {
    attrs: {
      "block": "",
      "variant": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('try-again');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.tryAgainLabel) + " ")]), _vm.showReload ? _c('b-button', {
    attrs: {
      "block": "",
      "variant": "outline-primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('reload');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.reloadLabel) + " ")]) : _vm._e()], 1) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };